import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Select,
  Steps,
  Tooltip,
} from "antd";
import ExistingUser from "../../assests/images/existinguser.svg";
import NewUser from "../../assests/images/newUser.svg";
import { useCallback, useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useNavigate } from "react-router";
import AuthService from "../../services/auth.service";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import { CONFIG } from "../../environment";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  allowOnlyAlphaNumericsWithSpecialChar,
} from "../../services/common.service";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { AiFillInfoCircle } from "react-icons/ai";
import OTPInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import moment from "moment";
import AuthLayout1 from "../../layout/AuthLayout/authLayout1";
import { RiHome5Line } from "react-icons/ri";
import CountrySelector from "../../components/countryCodeSelector";

const steps = [
  {
    content: "First-content",
  },
  {
    content: "second-content",
  },
  {
    content: "Last-content",
  },
];

export default function RegisterNow() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({});
  const [successVisible, setSuccessVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpVisible, setOtpVisible] = useState(false);
  const [seconds, setSeconds] = useState(CONFIG.OTP_TIMER % 60);
  const [minutes, setMinutes] = useState(Math.floor(CONFIG.OTP_TIMER / 60));
  const [userForm] = Form.useForm();
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const [verifyDetails, setVerifyDetails] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const defaultPickerValue = selectedDate
    ? selectedDate
    : dayjs().subtract(18, "years");
  const [termChecked, setTermChecked] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({
    isdCode: CONFIG?.DEFAULT_MOBILE_PREFIX,
    mobileLength: CONFIG?.MOBILE_NO_LENGTH,
  });
  const maxLength = parseInt(
    selectedCountry?.mobileLength || CONFIG?.MOBILE_NO_LENGTH
  );
  const ID_LENGTHS = {
    NATIONALID: { min: 14, max: 14 },
    PASSPORT: { min: 8, max: 12 },
    REFUGEEID: { min: 10, max: 20 },
  };
  const [lengthRange, setLengthRange] = useState({ min: 10, max: 20 });

  const handleTypeChange = (value) => {
    const { min, max } = ID_LENGTHS[value] || { min: 10, max: 35 };
    setLengthRange({ min, max });
    form.setFieldsValue({ uniqueIdValue: "" });
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const navigateToURL = () => {
    window.open().location.href = "https://ui.azaniabank.co.tz/onboard/#/phone";
  };

  useEffect(() => {
    if (stage === 3) {
      const interval = setInterval(() => {
        if (seconds <= 0) {
          if (minutes === 0) {
            clearInterval(interval);
          } else {
            setSeconds(59);
            setMinutes(minutes - 1);
          }
        } else {
          setSeconds(seconds - 1);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [minutes, seconds, stage]);

  const onVerify = useCallback(async (values) => {
    try {
      const reqParams = {
        ...values,
        customerDob: dayjs(values?.customerDob).format("YYYY-MM-DD"),
      };
      setFormValues(reqParams);
      const response = await AuthService.registerVerify(reqParams);
      if (response.status === 200) {
        setVerifyDetails(response.data);
        userForm.setFieldsValue({ userName: response.data?.customerId });
        setStage(2);
      }
    } catch (error) {
      setLoader(false);
    }
  }, []);

  const onVerifyUsername = useCallback(
    async (values) => {
      try {
        const reqParams = {
          userName: values?.userName || verifyDetails?.customerId,
        };
        setFormValues({ ...formValues, ...values });
        const response = await AuthService.registerUsernameCheck(reqParams);
        if (response.status === 200) {
          setLoader(false);
          setStage(3);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [formValues, verifyDetails]
  );

  const resendOtp = useCallback(async (values) => {
    try {
      setOtp("");
      const response = await AuthService.registerVerify({
        accountNumber: values?.accountNumber,
        mobileNo: values?.mobileNo,
        customerDob: dayjs(values.customerDob).format("YYYY-MM-DD"),
        smsPin: "",
      });
      if (response.status === 200) {
        setSeconds(CONFIG.OTP_TIMER);
      }
    } catch (error) {
      setOtp("");
    }
  }, []);

  const onConfirm = useCallback(
    async (values) => {
      try {
        const reqParams = {
          otp: values.otp,
          password: values.password,
          mobileNo: values?.mobileNo?.replace(/^0+/, ""),
          accountNumber: values.accountNumber,
          userName: values.userName || verifyDetails?.customerId,
          customerDob: values.customerDob,
          email: values.email,
          uniqueIdType: values?.uniqueIdType,
          uniqueIdValue:
            values.uniqueIdValue !== undefined ? values.uniqueIdValue : "",
          relationshipType: "CIF",
          smsPin: "",
          customerId: values.userName || verifyDetails?.customerId,
        };
        const response = await AuthService.registerConfirm(reqParams);
        if (response.status === 200) {
          setSeconds(0);
          navigate("/success", {
            state: { message: response.data["message"], routingURL: "/login" },
          });
          setMessage(response.data["message"]);
        }
      } catch (error) {
        setOtp("");
      }
    },
    [verifyDetails]
  );

  const termsAndConditions = useCallback(async () => {
    try {
      const response = await AuthService.getTermsAndConditions();
      if (response.status === 200) {
        window.open(response.data.url, "_blank");
      }
    } catch (err) {}
  }, []);
  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderSignUpLayout();
      case 1:
        return renderForm();
      case 2:
        return renderUserForm();
      case 3:
        return renderOtp();

      default:
        return renderForm();
    }
  }

  function renderSignUpLayout() {
    return (
      <div className="login-container">
        <img src={BANK_LOGO} height={50} className="mb-3" />
        <h3 className="mb-3 password-text" align="center">
          {t("pages.signup.signup_title", {
            defaultValue: "Register with Us",
          })}
        </h3>

        <p
          align="center"
          className="mb-3 secondary_txt_color_two"
          style={{ fontSize: "12px" }}
        >
          {t("pages.signup.sign_up_desc", {
            defaultValue:
              "Experience seamless banking with our user-friendly registration process. Join us today and enjoy a world of financial convenience.",
          })}
        </p>
        <div className="row">
          <div align="center" className="col-6">
            <Card className="card mb-3 " align="center" onClick={navigateToURL}>
              <div className="my-3">
                <img src={NewUser} alt="new" height={35} />
              </div>
              <div className="my-3">
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                  className="secondary_txt_color_two"
                >
                  {t("pages.signup.new_customer", {
                    defaultValue: "New Customer",
                  })}
                </span>
              </div>
            </Card>
          </div>
          <div align="center" className="col-6">
            <Card className="card" align="center" onClick={() => setStage(1)}>
              <div className="my-3">
                <img src={ExistingUser} alt="existing" height={30} />
              </div>
              <div className="my-3">
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                  className="secondary_txt_color_two"
                >
                  {t("pages.signup.", {
                    defaultValue: "Details for Internet Banking",
                  })}
                </span>
              </div>
            </Card>
          </div>
        </div>
        {/* <div className="login-auth-footer mb-5"></div> */}
      </div>
    );
  }

  function renderForm() {
    return (
      <>
        <div
          style={{
            position: "fixed",
            display: "contents",
            top: "0",
          }}
        >
          {/* <div className="back-footer">
              <span
                onClick={() => navigate("/login")}
                style={{ cursor: "pointer" }}
              >
                <BackIcon
                  width={40}
                  style={{ margin: "10px 30px", marginTop: "20px" }}
                />
              </span>
            </div> */}
        </div>
        <div align="center">
          <div className="col-12  ">
            <div className="vertical-center" align="left">
              {stage !== 0 && (
                <div>
                  <img src={BANK_LOGO} height={50} className="mb-3" />
                  <h5 className="mb-2 " align="left">
                    {t("pages.signup.", {
                      defaultValue: "Details for Internet Banking",
                    })}
                  </h5>
                  <p
                    className="secondary_txt_color_two"
                    style={{
                      fontSize: "14px",
                    }}
                    align="left"
                  >
                    {t("pages.signup.please_give_details", {
                      defaultValue: "Please give below details",
                    })}
                  </p>
                  <Steps
                    current={stage - 1}
                    labelPlacement="vertical"
                    style={{ marginBottom: "20px", width: "70%" }}
                    className="custom-hide-stepper"
                  >
                    {steps.map((step, index) => (
                      <Steps
                        key={step.title}
                        title={step.title}
                        icon={<span>{index + 1}</span>}
                      />
                    ))}
                  </Steps>
                </div>
              )}
              <div className="">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onVerify}
                  initialValues={formValues}
                >
                 {CONFIG.CIF ? (
                  <Form.Item
                  label={t("common.customer_id", {
                    defaultValue: "Customer ID",
                  })}
                  name="customerId"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.customer_id_required", {
                        defaultValue: "Customer ID is required",
                      }),
                    },
                  ]}
                >
                  <NumericFormat
                    placeholder={t("common.customer_id", {
                      defaultValue: "Customer ID",
                    })}
                    allowNegative={false}
                    allowLeadingZeros={true}
                    customInput={Input}
                    size="large"
                  />
                </Form.Item>
                 ) : (
                  <Form.Item
                    label={t("common.account_no_lbl", {
                      defaultValue: "Account Number",
                    })}
                    name="accountNumber"
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.account_no_requir", {
                          defaultValue: "Account Number is required",
                        }),
                      },
                    ]}
                  >
                    <NumericFormat
                      placeholder={t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                      allowNegative={false}
                      allowLeadingZeros={true}
                      customInput={Input}
                      size="large"
                    />
                  </Form.Item>
                    )}

                  <Form.Item
          label={t("common.mobile_number", {
            defaultValue: "Mobile Number",
          })}
          name="mobileNo"
          rules={[
            {
              required: true,
              message: t("errorMesssages.mobile_no_requir", {
                defaultValue: "Mobile Number is required",
              }),
            },
            {
              min: maxLength,
              max: maxLength,
              message: t("errorMesssages.mobile_no_invalid", {
                defaultValue: `Please enter a valid Mobile Number`,
              }),
            },
          ]}
        >
          <NumericFormat
            maxLength={maxLength}
            placeholder={t("common.mobile_number", {
              defaultValue: "Mobile Number",
            })}
            allowLeadingZeros={true}
            allowNegative={false}
            customInput={Input}
            autoComplete="off"
            size="large"
            addonBefore={
              <CountrySelector
                selectedCountryCode={selectedCountry?.isdCode}
                onChange={(selected) => setSelectedCountry(selected)}
              />
            }
          />
                  </Form.Item>

                  <Form.Item
                    label={t("pages.forgotPassword.date_of_birth", {
                      defaultValue: "Date of Birth",
                    })}
                    name={"customerDob"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.date_of_birth_required", {
                          defaultValue: "Date Of Birth is required",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      value={selectedDate}
                      onChange={handleDateChange}
                      defaultPickerValue={defaultPickerValue}
                      disabledDate={(current) =>
                        current.isAfter(moment().subtract(18, "years"))
                      }
                      placeholder="DD-MM-YYYY"
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      size="large"
                      showToday={false}
                    />
                  </Form.Item>
                  {CONFIG.REFUGEEID ? (
                    <>
                      <Form.Item
                        label={t("pages.login.unique_id", {
                        defaultValue: "Unique Id Type",
                        })}
                        name={"uniqueIdType"}
                        rules={[
                          {
                            required: true,
                            message: t("errorMesssages.unique_id_required", {
                            defaultValue: "Unique ID Type is required",})
                          },
                        ]}
                      >
                        <Select placeholder={t("pages.login.unique_id", {
                        defaultValue: "Unique Id Type",
                        })} size="large" onChange={handleTypeChange}>
                          <Select.Option value={"NATIONALID"}>NATIONAL ID</Select.Option>
                          <Select.Option value={"PASSPORT"}>PASSPORT</Select.Option>
                          <Select.Option value={"REFUGEEID"}>REFUGEE ID</Select.Option>
                        </Select>
                      </Form.Item>

                      <Form.Item
                         label={t("pages.login.unique_value", {
                          defaultValue: "Identity Number",
                          })}
                        name="uniqueIdValue"
                        rules={[
                          { required: true, 
                            message: t("errorMesssages.unique_value_required", {
                            defaultValue: "Identity Number is required",})
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const type = getFieldValue("uniqueIdType");
                              if (!type || !value) return Promise.resolve();

                              const { min, max } = ID_LENGTHS[type] || {};
                              if (value.length < min || value.length > max) {
                                return Promise.reject( 
                                  type === "NATIONALID" ?  
                                  `Identity Number should be ${max} characters`
                                  : `Identity Number should be between ${min} to ${max} characters`
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder={t("pages.login.unique_value", {
                          defaultValue: "Identity Number",
                          })}
                          minLength={lengthRange.min}
                          maxLength={lengthRange.max}
                          onKeyPress={(e) => allowOnlyAlphaNumericsWithSpecialChar(e)}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item
                        label={"Unique ID Type"}
                        name={"uniqueIdType"}
                        rules={[
                          {
                            required: true,
                            message: "Unique ID Type is required",
                          },
                        ]}
                      >
                        <Select placeholder={"Unique ID Type"} size="large">
                          <Select.Option value={"NATIONALID"}>
                            NATIONAL ID
                          </Select.Option>
                          <Select.Option value={"PASSPORT"}>PASSPORT</Select.Option>
                          <Select.Option value={"DRIVINGLICENSE"}>
                            DRIVING LICENSE
                          </Select.Option>
                        </Select>
                      </Form.Item>

                      <Form.Item
                        label={"Identity Number"}
                        name="uniqueIdValue"
                        rules={[
                          {
                            required: true,
                            message: "Identity Number is required",
                          },
                        ]}
                      >
                        <Input size="large"  maxLength={35} placeholder="Identity Number"
                          onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                        />

                      </Form.Item>
                    </>
                  )}

                  {/* <Form.Item
                    name="email"
                    label={t("common.email", {
                      defaultValue: "Email Address",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.email_id_require", {
                          defaultValue: "Email Address is required",
                        }),
                      },
                      {
                        type: "email",
                        message: t("errorMesssages.invalid_email", {
                          defaultValue: "Invalid Email Address",
                        }),
                      },
                    ]}
                  >
                    <Input
                      maxLength={35}
                      placeholder={t("common.email", {
                        defaultValue: "Email Address",
                      })}
                      size="large"
                    />
                  </Form.Item> */}

                  {/* <label
                      className="form-check-label control-label"
                      style={{
                        textAlign: "center",
                        width: "350px",
                        margin: "0 auto",
                        display: " block",
                      }}
                      htmlFor="tnc"
                    >
                      By confirming this transaction, you agree to its{" "}
                      <span
                        onClick={() => SetShowModal(true)}
                        style={{ color: "blue", cursor: "pointer" }}
                        type="button"
                        data-toggle="modal"
                        data-target=".bd-example-modal-lg"
                      >
                        Terms and Conditions
                      </span>
                    </label> */}

                  {/* <Form.Item
              label={
                <>
                  {t("common.sms_code", {
                    defaultValue: "SMS Code",
                  })}
                  <Tooltip
                    overlayClassName="overlayStyle"
                    placement="top"
                    title={t("common.sms_code_tip", {
                      defaultValue: "SMS Code will be sent from USSD",
                    })}
                  >
                    <AiFillInfoCircle
                      size={18}
                      style={{ marginLeft: 10 }}
                      className="primary-color"
                    />
                  </Tooltip>
                </>
              }
              name="smsPin"
              rules={[
                {
                  required: true,
                  message: t("errorMesssages.sms_code_requir", {
                    defaultValue: "SMS Code is required",
                  }),
                },
              ]}
            >
              <NumericFormat
                placeholder={t("common.sms_code", {
                  defaultValue: "SMS Code",
                })}
                allowLeadingZeros={true}
                allowNegative={false}
                customInput={Input}
                size="large"
              />
            </Form.Item> */}

            <Checkbox
          onClick={(e) => {
            setTermChecked(e.target.checked);
          }}
          className="mb-3"
          tabIndex={5}
        >
          {t("signup.t&c_agree_msg1", {
            defaultValue: "I have read, understood and agree to the product",
          })}
          {" "}
          <b
            style={{ color: "var(--primary_color)" }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              termsAndConditions();
            }}
          >
            {t("signup.t&c_agree_msg2", {
            defaultValue: "terms and conditions and data privacy statement",
          })}
            
          </b>
        </Checkbox>
                  <Button
                    className="login-button mt-2 mb-3"
                    block
                    size="large"
                    type="primary"
                    htmlType="submit"
                    disabled={!termChecked}
                  >
                    {t("buttons.submit_btn", {
                      defaultValue: "Submit",
                    })}
                  </Button>
                </Form>
                {/* <Button type="link" className="mt-3" block onClick={() => setStage(0)}>
            {t("buttons.back_btn", {
                defaultValue: "Back",
              })}
          </Button> */}
                {/* <div className="login-auth-footer mb-5"></div> */}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  function renderUserForm() {
    return (
      <>
        <div
          style={{
            position: "fixed",
            display: "contents",
            top: "0",
          }}
        >
          {/* <div className="back-footer">
              <span
                onClick={() => navigate("/login")}
                style={{ cursor: "pointer" }}
              >
                <BackIcon
                  width={40}
                  style={{ margin: "10px 30px", marginTop: "20px" }}
                />
              </span>
            </div> */}
        </div>
        <div align="">
          <div className="">
            <div className="vertical-center" align="left">
              {stage !== 0 && (
                <div>
                  <img src={BANK_LOGO} height={50} className="mb-3" />
                  <h5 className="mb-2 " align="left">
                    {t("pages.signup.", {
                      defaultValue: "Set Password",
                    })}
                  </h5>
                  <p
                    className="secondary_txt_color_two"
                    style={{
                      fontSize: "14px",
                    }}
                    align="left"
                  >
                    {t("pages.signup.please_give_details", {
                      defaultValue: "Please give below details",
                    })}
                  </p>
                  <Steps
                    current={stage - 1}
                    labelPlacement="vertical"
                    style={{ marginBottom: "20px", width: "70%" }}
                    className="custom-hide-stepper"
                  >
                    {steps.map((step, index) => (
                      <Steps
                        key={step.title}
                        title={step.title}
                        icon={<span>{index + 1}</span>}
                      />
                    ))}
                  </Steps>
                </div>
              )}
              <div className="">
                <Form
                  form={userForm}
                  layout="vertical"
                  className="mt-2"
                  onFinish={onVerifyUsername}
                >
                  {verifyDetails?.populateCif ? (
                    <Form.Item
                      label={t("common.customer_id", {
                        defaultValue: "Customer Id",
                      })}
                      name="userName"
                    >
                      <Input
                        onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                        maxLength={20}
                        size="large"
                        placeholder={t("common.customer_id", {
                          defaultValue: "Customer Id",
                        })}
                        defaultValue={verifyDetails?.customerId}
                        readOnly
                      />
                    </Form.Item>
                  ) : (
                    <Form.Item
                      label={
                        <>
                          {t("pages.login.userName", {
                            defaultValue: "Username",
                          })}
                          <Tooltip
                            placement="top"
                            overlayClassName="overlayUsername"
                            title={
                              <div className="password-criteria">
                                <h6>
                                  {t("pages.forcePassword.username_tip", {
                                    defaultValue: "Username Criteria",
                                  })}
                                </h6>
                                <ul>
                                  <li>
                                    {t("pages.forcePassword.min_char", {
                                      defaultValue: "Minimum 8 characters",
                                    })}
                                  </li>
                                  <li>
                                    {t("pages.forcePassword.max_char", {
                                      defaultValue: "Maximum 20 characters",
                                    })}
                                  </li>
                                  <li>
                                    {t("pages.forcePassword.no_special", {
                                      defaultValue:
                                        "Should not contain special characters",
                                    })}
                                  </li>
                                </ul>
                              </div>
                            }
                          >
                            <AiFillInfoCircle
                              size={18}
                              style={{ marginLeft: 10 }}
                              className="primary-color"
                            />
                          </Tooltip>
                        </>
                      }
                      name="userName"
                      rules={[
                        {
                          required: true,
                          message: t("errorMesssages.userName_required", {
                            defaultValue: "Username is required",
                          }),
                        },
                        {
                          min: 8,
                          max: 20,
                          message: t(
                            "errorMesssages.userName_min_max_required",
                            {
                              defaultValue:
                                "Username should be between 8 to 20 characters",
                            }
                          ),
                        },
                      ]}
                    >
                      <Input
                        onKeyPress={(e) =>
                          allowOnlyAlphaNumericsWithSpecialChar(e)
                        }
                        maxLength={20}
                        size="large"
                        placeholder={t("pages.login.userName", {
                          defaultValue: "Username",
                        })}
                      />
                    </Form.Item>
                  )}
                  <Form.Item
                    label={
                      <>
                        {t("pages.login.password", {
                          defaultValue: "Password",
                        })}
                        <Tooltip
                          placement="top"
                          overlayClassName="overlayUsername"
                          title={
                            <div className="password-criteria">
                              <h6>Password Criteria</h6>
                              <ul>
                                <li>
                                  Require a combination of uppercase and
                                  lowercase letters
                                </li>
                                <li>Minimum Special Character(@#&*!): 1</li>
                                <li>Minimum Password Length: 8 </li>
                                <li>Password Minimum Character: 2</li>
                                <li>Password Minimum Digits: 1</li>
                                <li>Maximum Password Length: 20</li>
                              </ul>
                            </div>
                          }
                        >
                          <AiFillInfoCircle
                            size={18}
                            style={{ marginLeft: 10 }}
                            className="primary-color"
                          />
                        </Tooltip>
                      </>
                    }
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.password_required", {
                          defaultValue: "Password is required",
                        }),
                      },
                      {
                        pattern: new RegExp(
                          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#&*!])[A-Za-z\d@#&*!]{8,}$/
                        ),
                        message: t("errorMesssages.password_criteria", {
                          defaultValue:
                            "Password should match Password Criteria!",
                        }),
                      },
                    ]}
                  >
                    <Input.Password
                      maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
                      size="large"
                      placeholder={t("pages.login.password", {
                        defaultValue: "Password",
                      })}
                      minLength={CONFIG?.PASSWORD_MIN_LENGTH}
                    />
                  </Form.Item>

                  <Form.Item
                    label={t("pages.forgotPassword.confirm_pass", {
                      defaultValue: "Confirm Password",
                    })}
                    name="cPassword"
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.confirm_password_required", {
                          defaultValue: "Confirm Password is required",
                        }),
                      },
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            t("errorMesssages.password_do_not_match", {
                              defaultValue: "Passwords do not match!",
                            })
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
                      size="large"
                      placeholder="Confirm Password"
                      minLength={CONFIG?.PASSWORD_MIN_LENGTH}
                    />
                  </Form.Item>

                  <Button
                    className="login-button mt-2"
                    block
                    size="large"
                    type="primary"
                    htmlType="submit"
                    loading={loader}
                  >
                    {t("buttons.next_btn", {
                      defaultValue: "Next",
                    })}
                  </Button>

                  <Button
                    onClick={() => setVisible(true)}
                    type="link"
                    className="mt-3 mb-3"
                    block
                    size="large"
                  >
                    {t("buttons.cancel_btn", {
                      defaultValue: "Cancel",
                    })}
                  </Button>
                  {/* <div className="login-auth-footer mb-5"></div> */}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  function renderOtp() {
    return (
      <>
        <div
          style={{
            position: "fixed",
            display: "contents",
            top: "0",
          }}
        >
          {/* <div className="back-footer">
              <span
                onClick={() => navigate("/login")}
                style={{ cursor: "pointer" }}
              >
                <BackIcon
                  width={40}
                  style={{ margin: "10px 30px", marginTop: "20px" }}
                />
              </span>
            </div> */}
        </div>
        <div align="center">
          <div className="">
            <div className="vertical-center" align="left">
              {stage !== 0 && (
                <div>
                  <img src={BANK_LOGO} height={50} className="mb-3" />
                  <div className="d-flex justify-content-between mb-3 align-items-center">
                    <div
                      style={{
                        fontWeight: 600,
                      }}
                      className=""
                    >
                      <h5
                        className="text-left secondary_txt_color_two mb-0"
                        align="left"
                        style={{ fontSize: "25px" }}
                      >
                        {t("pages.otp.verifyusingotp", {
                          defaultValue: "Verify Using OTP",
                        })}
                      </h5>
                    </div>
                    <b>
                      {seconds > 0 || minutes > 0 ? (
                        <p style={{ fontSize: "25px" }} className="mb-0">
                          {minutes < 10 ? `0${minutes}` : minutes}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </p>
                      ) : (
                        <div align="center" className="otp-pretimeout">
                          <div className="d-flex justify-content-around ">
                            <span
                              onClick={() => {
                                const totalSeconds = CONFIG.OTP_TIMER;
                                setMinutes(Math.floor(totalSeconds / 60));
                                setSeconds(totalSeconds % 60);
                                onVerifyUsername();
                                setOtp("");
                              }}
                            >
                              Resend OTP
                            </span>
                          </div>
                        </div>
                      )}
                    </b>
                  </div>
                </div>
              )}
              <div className="">
                {/* <div align="center" className="mb-5">
            <img src={logo} height={70} />
          </div> */}
                <div style={{ margin: "0 auto" }}>
                  <p
                    className="text-left secondary_txt_color_two"
                    align="left"
                    style={{
                      fontSize: "13px",
                      marginBottom: "40px",
                    }}
                  >
                    {t("pages.otp.otpTitle", {
                      defaultValue:
                        "We have sent OTP code to a number end with",
                    })}{" "}
                    <b style={{ color: "black" }}>
                      XX
                      {formValues?.mobileNo?.slice(
                        formValues?.mobileNo?.length - 2
                      )}{" "}
                    </b>
                    {t("pages.otp.otpSubTitle", {
                      defaultValue:
                        "and your email, Please use that code to verify",
                    })}
                  </p>
                  <Steps
                    current={stage - 1}
                    labelPlacement="vertical"
                    style={{ marginBottom: "20px", width: "70%" }}
                    className="custom-hide-stepper"
                  >
                    {steps.map((step, index) => (
                      <Steps
                        key={step.title}
                        labelPlacement="vertical"
                        title={step.title}
                        icon={<span>{index + 1}</span>}
                      />
                    ))}
                  </Steps>
                  <div className="mt-4">
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={CONFIG.OTP_LENGTH}
                      onPaste={false}
                      shouldAutoFocus={false}
                      skipDefaultStyles={true}
                      inputStyle={{
                        width: 70,
                        height: 70,
                        display: "inline-block",
                        textAlign: "center",
                        borderRadius: "50% !important",
                        marginRight: 15,
                        fontSize: 20,
                      }}
                      inputType="password"
                      containerStyle={"input-otp-style"}
                      renderInput={(props) => (
                        <Input
                          className="input-otp-style"
                          size="large"
                          {...props}
                        />
                      )}
                    />

                    <Button
                      size="large"
                      block
                      className="mt-2 login-button"
                      type="primary"
                      disabled={otp.length !== CONFIG.OTP_LENGTH}
                      onClick={() => onConfirm({ ...formValues, otp: otp })}
                    >
                      {t("buttons.verify", {
                        defaultValue: "Verify",
                      })}
                    </Button>

                    <Button
                      onClick={() => setVisible(true)}
                      type="link"
                      className="mt-3 mb-3 "
                      block
                      size="large"
                    >
                      {t("buttons.cancel_btn", {
                        defaultValue: "Cancel",
                      })}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <AuthLayout1 module="register" title="Register for Internet Banking">
        <div className="auth-card">
          <PerfectScrollbar>
            <div className="p-5 login-card-padding">{renderSwitch()}</div>
          </PerfectScrollbar>
        </div>
      </AuthLayout1>

      <Modal
        title={t("pages.otp.quit", {
          defaultValue: "Quit ?",
        })}
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        width={480}
        mask={true}
      >
        <p>
          {t("pages.otp.quitTitle", {
            defaultValue:
              "If you quit now, you will have to start all over again. Are you sure you want to quit?",
          })}
        </p>

        <div className="mt-3" align="right">
          <Button
            type="link"
            onClick={() => setVisible(false)}
            className="mx-4 secondary-btn"
            size="large"
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="login-button"
            onClick={() => {
              setVisible(false);
              setSeconds(0);
              navigate("/login");
            }}
            size="large"
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                setOtpVisible(false);
                navigate("/login");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
